module.exports = __webpack_public_path__ + "media/images/consumer/account/upcoming-menus/mobile-promo/device-f2dfdb27dfcf6a39271c49fb363fec3c.png";